import { render, staticRenderFns } from "./GUploader.vue?vue&type=template&id=e21b33e6&scoped=true&"
import script from "./GUploader.vue?vue&type=script&lang=js&"
export * from "./GUploader.vue?vue&type=script&lang=js&"
import style0 from "./GUploader.vue?vue&type=style&index=0&id=e21b33e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21b33e6",
  null
  
)

export default component.exports